module.exports = __webpack_public_path__ + "static/img/aboutus.fbed929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/aboutus.jpg
// module id = JPko
// module chunks = 1